module.exports = __webpack_public_path__ + "/static/assets/f9dce53613d5f85b311ce9f84423c08b.svg";